module.exports = __webpack_public_path__ + "4dedaccff2c61b9df124cd742df39a89.pdf";